export default __webpack_public_path__ + "static/media/logo-SparkleSm.55d53aee.svg";